import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';
import { FILTER_VALUES } from '../../constants/FilterConstants';

const defaultFilterState = {
  [FILTER_VALUES.CURRENCY_FILTER]: [],
  [FILTER_VALUES.PROVIDER_FILTER]: null,
  [FILTER_VALUES.DATE_RANGE]: { from: '', to: '' },
  [FILTER_VALUES.FETCHED_TIMEFRAME_RANGE]: { from: '', to: '' },
  [FILTER_VALUES.UPDATED_BY_FILTER]: [],
  searchText: '',
  pageNumber: DEFAULT_PAGE,
  rowsPerPage: DEFAULT_PER_PAGE,
};

const initialState = {
  exchangeRates: { ...defaultFilterState },
};

const exchangeRatesFiltersSlice = createSlice({
  name: 'exchangeRatesFilters',
  initialState,
  reducers: {
    setExchangeRatesFilters(state, action) {
      if (!state.exchangeRates) state.exchangeRates = { ...defaultFilterState };
      state.exchangeRates[FILTER_VALUES.CURRENCY_FILTER] = action.payload?.[FILTER_VALUES.CURRENCY_FILTER] ?? [];
      state.exchangeRates[FILTER_VALUES.PROVIDER_FILTER] = action.payload?.[FILTER_VALUES.PROVIDER_FILTER] ?? null;
      state.exchangeRates[FILTER_VALUES.DATE_RANGE] = action.payload?.[FILTER_VALUES.DATE_RANGE] ?? {
        from: '',
        to: '',
      };
      state.exchangeRates[FILTER_VALUES.FETCHED_TIMEFRAME_RANGE] = action.payload?.[
        FILTER_VALUES.FETCHED_TIMEFRAME_RANGE
      ] ?? {
        from: '',
        to: '',
      };
      state.exchangeRates[FILTER_VALUES.UPDATED_BY_FILTER] = action.payload?.[FILTER_VALUES.UPDATED_BY_FILTER] ?? [];
      state.exchangeRates.searchText = action.payload?.searchText ?? '';
      state.exchangeRates.pageNumber = action.payload?.pageNumber || DEFAULT_PAGE;
      state.exchangeRates.rowsPerPage = action.payload?.rowsPerPage || DEFAULT_PER_PAGE;
    },
    resetExchangeRatesState(state) {
      state.exchangeRates = { ...defaultFilterState };
    },
  },
});

export const { setExchangeRatesFilters, resetExchangeRatesState } = exchangeRatesFiltersSlice.actions;

export default exchangeRatesFiltersSlice;
